/**
 * Zentrale Branding-Konfiguration — Auswahl zur Build-Zeit ueber VITE_BRAND
 * (Default "rheinmetall"). Logos liegen unter public/branding/<brand>/.
 *
 * EnvBadge-Farben (dev orange / stage blau / prod gruen) sind FUNKTIONAL und
 * gehoeren NICHT hierher (components/shared/EnvBadge.tsx bleibt unangetastet).
 */

export interface Branding {
  /** Brand-Schluessel (= Ordnername unter public/branding/) */
  brand: string
  /** App-Titel (Sidebar, document.title) */
  appName: string
  /** Kundenname (Anzeige, z. B. Footer/Impressum) */
  customerName: string
  /** Vollmarke fuer hellen Hintergrund (null = keine Bildmarke vorhanden) */
  logo: string | null
  /** Vollmarke fuer dunklen Hintergrund */
  logoDark: string | null
  /** Bildmarke/Symbol (Sidebar-Kopf, eingeklappt) */
  symbol: string | null
  /** Monogramm-Fallback, wenn keine Bildmarke vorhanden ist */
  monogram: string
}

const BRAND = import.meta.env.VITE_BRAND || "rheinmetall"

// Assets liegen in public/ und werden von Vite NICHT umgeschrieben. Die
// Template-Literale unten faltet Vite dagegen beim Bauen zu fertigen Pfaden —
// der gebaute Bundle laesst sich damit durch Hinsehen pruefen
// (rmnc-plattform Entscheidung 010).

const BRANDS: Record<string, Branding> = {
  rheinmetall: {
    brand: "rheinmetall",
    appName: "RMNC Personal",
    customerName: "Rheinmetall NC",
    logo: `${import.meta.env.BASE_URL}branding/rheinmetall/logo.svg`,
    logoDark: `${import.meta.env.BASE_URL}branding/rheinmetall/logo-dark.svg`,
    symbol: `${import.meta.env.BASE_URL}branding/rheinmetall/symbol.svg`,
    monogram: "RP",
  },
  netzfabrik: {
    brand: "netzfabrik",
    appName: "RMNC Personal",
    customerName: "Netzfabriks",
    logo: null,
    logoDark: null,
    symbol: null,
    monogram: "RP",
  },
}

export const branding: Branding = BRANDS[BRAND] ?? BRANDS.rheinmetall
